module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n"
  }, [_c('span', [_vm._v("Chapter 2")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("GENESIS 1—11")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Next to the parables of Jesus the stories of Genesis 1—11 must be the most familiar part of the Bible. Nearly everyone has heard of Adam and Eve, the Flood, and the tower of Babel. Yet at the same time it is the most contentious: some people dismiss it as myth or fairy tale, while others hold it to be good science and accurate history. And as far as the New Testament and early Christian writers were concerned this was the part of the Old Testament that was most influential in the formulation of Christian doctrine. Here the stakes are high and tempers rise: even mild-mannered scholars have been known to damn opposing interpreters of these chapters angrily. So I shall try to tread carefully and I hope readers will be charitable.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("At the heart of the debate is the question of genre: that is, what kind of literature are we dealing with here? In trying to answer this question, we need to enquire how Genesis 1—11 relates to the rest of the book, and whether there are any parallels to this material inside or outside the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I shall take these issues in reverse order. First, we shall compare Genesis’ account of world origins with other texts discovered in the Middle East to see what light this sheds on the nature of Genesis 1—11. Then we shall review the contents of Genesis 1—11 to see both how it is similar to and how it differs from the stories told by other peoples from that era and area. Finally we shall discuss the relationship of Genesis 1—11 to the rest of the book, where the author’s main concerns are most evident. By this means I hope we shall come to a better understanding of what the writer of Genesis was trying to say to his readers when he put pen to paper some 3000 years ago. Indirectly this should shed light on the issues that so perplex modern readers, when they approach Genesis conditioned by a scientific and historical mindset whose assumptions differ from those of past ages.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("ANCIENT NEAR EASTERN PARALLELS TO GENESIS 1—11")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("It was in 1872 that George Smith, a curator in the British Museum, discovered ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("the first close parallel to Genesis 1—11. Translating a cuneiform tablet found in the Assyrian library of Ashurbanipal (seventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") at Nineveh, he realized he had an account of a world- wide flood that in many respects resembled the story told in Genesis. Subsequently it was recognized that the flood story formed part of the Gilgamesh epic, a tale of a great king who dropped out of his royal role to travel the world in a quest for immortality. The Gilgamesh epic was probably composed in about 1700 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" and then revised in about 1200 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" to produce the best-known standard version of the epic. Scholars think that the flood story was probably borrowed by the author of the Gilgamesh epic from another source, who then used it to enhance his own tale.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A possible source for the flood story is the Atrahasis epic, another Old Babylonian classic, which covers the history of the world from the creation of man to the new order established after the flood. It begins when the minor gods lived on earth excavating the rivers and canals and growing food for the great gods. But after 3600 years the minor gods became tired of their work and went on strike. They besieged the great god Enlil in his palace, who eventually caved in to their demands! Another great god Ea and the mother goddess Nintu then created seven human couples, seven men and seven women, to do the work of the minor gods.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("But the creation of mankind led to problems for the great gods. After 600 years the population had increased so much that their racket stopped the great gods sleeping! Enlil therefore decreed that a plague should blot them out. But a timely sacrifice to the plague god by Atrahasis, or ‘Extra-wise’ stopped the plague. But then the population grew again, and twice more Enlil tried to check it by drought and famine. But once again sacrifices to the right gods saved the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Eventually Enlil persuaded all his fellow gods to back his plan to destroy mankind by sending a flood. However, the god Ea disagreed with this proposal and secretly tipped off Atrahasis to build an ark for his family, friends and animals to escape in. The flood was indeed catastrophic, wiping out all living creatures and scaring the gods by its ferocity. But Atrahasis and his crew survived. The ark eventually landed on a mountain and those inside disembarked.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Pious Atrahasis offered a sacrifice as soon as he landed. Immediately the gods crowded round the sacrifice anxious to enjoy the barbecue. They were very hungry! Destroying mankind in a flood meant that all sacrifices had stopped and the gods had had nothing to eat. A little late Enlil, the most powerful god, turned up at the sacrifice and was shocked and angry to find some human beings had escaped. He calmed down when the other gods explained it was Ea’s fault, and he granted Atrahasis eternal life, the only man to achieve this.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("However, to stop the population explosion ever getting out of hand again Enlil had ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("the mother goddess redesign man a little. From now on some women would suffer from infertility, babies would often be stillborn or die very young, and yet other women would enter religious orders and never have children. Finally it seems likely that from then on death would now come to everyone in old age: up to this time people died only from disease or if they were killed by someone.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Another text from about the same period as the Atrahasis epic is the Sumerian flood story. It too tells of the creation of mankind and culminates with the story of the great flood. Unfortunately many parts of the Sumerian story are lost, but as reconstructed it parallels Genesis 1—9 quite strikingly.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("There are enough similarities in the storylines of Genesis and the Sumerian flood story to show that both are dependent on a common understanding of what took place at the dawn of human history. However, we shall see that the spin the storytellers put on those events is quite different. But clearly both Genesis 1—11 and the Sumerian Flood Story have a similar character or genre: that is why the scholar who edited the Sumerian story entitled it ‘the Eridu Genesis’.")]), _vm._v(" "), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("What do you think?")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("REWRITING THE STORY OF HUMAN ORIGINS")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Read the story of creation in Genesis 2 and the flood in Genesis 6—9 and compare it with the account above. What similarities and differences do you notice? How does Genesis change the story? What do these changes tell us about the writer’s attitude?")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If you have access to other texts read the whole Babylonian version. Note that in Gilgamesh tablet 11 Atrahasis is usually called Ut- Napishtim (‘He found life’).")])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-002"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("PARALLELS BETWEEN THE SUMERIAN FLOOD STORY AND GENESIS 1—9")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "70%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Sumerian Flood Story")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Contents")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Genesis")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Lines 1–36")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Creation of man and animals; man’s sad plight, no irrigation canals, no clothes, no fear of animals including snakes")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 1")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 2—3")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("37–50")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Goddess Nintur’s plan to end human nomadism")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 4:1–16")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("51–85")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Failure of Nintur’s plan")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("86–100")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Establishment of kingship; building of first cities, including Eridu Establishment of worship")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 4:17–18")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 4:26")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("101–34")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("List of antediluvian kings Man’s noise")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 5")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 6:1–8")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("135–260")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The flood")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gen. 6:9—9:29")])])])])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("A fourth ancient text that has some obvious similarities to Genesis is the Sumerian King List, which in an early form dates to about 1900 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". This king list mentions eight, nine or ten kings who reigned before the flood (ancient versions differ as to the number of antediluvian kings). Then it mentions that the flood came, and after that kingship was reintroduced and it lists the kings who reigned in different centres and for how long.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("THE SUMERIAN KING LIST OPENING LINES")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When kingship was lowered from heaven, kingship was first in Eridu. In Eridu Alulim became king and ruled 28,800 years. Alalgar ruled 36,000 years. Two kings thus ruled it for 64,800 years.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("(Six more kings in four other towns are mentioned)")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These are five cities, eight kings ruled them for 241,000 years.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Then the Flood swept over the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After the Flood had swept over the earth and when kingship was lowered again from heaven, kingship was first in Kish. In Kish, Ga..ur became king and ruled 1200 years … Pala- kinatim ruled 900 years … Kalibum ruled 960 years; Qalumum ruled 840 years; Zuqapip ruled 900 years; …")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Twenty-three kings thus ruled it for 24,510 years, 3 months, and 3"), _c('sup', [_vm._v("1")]), _vm._v("/2 days.")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This King List resembles Genesis 5—11 in four respects. First, it presents history in list form, which parallels the genealogies in Genesis 5 and 11. Second, it divides early human history into three phases, pre-flood, flood and post-flood. Third, it claims that kings reigned much longer before the flood than afterwards, just as the pre-flood heroes in Genesis 5 live much longer than the post-flood heroes of Genesis 11. Fourth, the number of pre- flood kings (8, 9 or 10) is very similar to the ten generations from Adam to Noah listed in Genesis 5. Nevertheless, the names of the kings are quite different from the commoners listed in the Bible, so that we cannot suppose there was any borrowing by the Bible from the Sumerian list. But once again we have a piece of literature similar in genre and from the same general period and place as Genesis 1—11, so that we can appeal to one to clarify the nature of the other.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Having surveyed a number of ancient texts that are close in content and time to Genesis 1—11, we are in a better position to discuss the question of the genre of these chapters. Modern writers on Genesis often describe its opening chapters as ‘myth’; though when their concept of myth is unpacked, it may not correspond very closely to the dictionary definition. As the dictionary shows, the primary sense of myth is something fictitious or untrue. ‘That’s a complete myth’ we say, if we want to rubbish someone else’s views.")])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "enc_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("What do you think?")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("THE DEFINITION OF MYTH")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A myth may be defined as a ‘purely fictitious narrative usually involving supernatural persons etc and embodying popular ideas on natural phenomena etc.; fictitious person or thing.’ "), _c('i', [_vm._v("Concise Oxford Dictionary")])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Read Genesis 1—11. How far do you think it fits this definition of myth? How else might these chapters be characterized?")])])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though we may find aspects of these stories extraordinary, it seems quite clear that they are not entirely fictitious. Gilgamesh and Atrahasis were real kings to whom these stories became attached, perhaps a bit like King Arthur or Robin Hood. The Sumerian King List not only involves real places, but some of the later kings have left inscriptions proving they existed.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Furthermore, it has been observed that these ancient oriental texts are akin to history in that they set events in a chain of cause and effect. The kindly goddess Nintur sees primitive man’s wretched state, so she provides him with cities to live and kings to organize society. This works so well that the human population grows, which in turn disturbs the peace of the gods. They react by sending plague, famine and flood. Jacobsen comments: ‘This arrangement along a line of time as cause and effect is striking, for it is very much the way a historian arranges his data’ (Jacobsen 1981, p. 528).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The obvious interest in chronology in the Sumerian and biblical texts is also striking. Both give precise lengths of reign or life spans of the people they mention. The numbers are admittedly incredibly large, but the interest in chronology is more characteristic of historiography and chronicles than folktales or myth. The latter are usually unconcerned with time: they float outside time. Often they begin ‘Once upon a time,’ and end with ‘they lived happily ever after’. For this reason Jacobsen believes these ancient stories should be classified as mytho- historical accounts.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Despite drawing attention to the history- like features of these texts, Jacobsen still describes them as mytho-historical, i.e. he regards them as myths told as though they were history. Modern definitions of myth often rest on two features: that they are stories about the gods and that they explain aspects of present life. How far is this true of the stories we have been considering?")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("It is striking that modern scholars have not called any of the Mesopotamian texts we have been considering myths. Rather they are called epics (Gilgamesh, Atrahasis), Flood Story or King List, for gods are hardly mentioned in the King List and in the others it is the human ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("characters who are the focus of the narrative. Genesis 1—11 is similar: though God is of course active, his actions are all related to man. Nothing is said about his interactions with other spiritual beings. Thus modern commentators tend to avoid describing Genesis 1—11 as myth. If the only reason for calling Genesis 1—11 a myth is because God is present in the story, one would have to call the whole Bible a myth, which few would wish to do.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is certainly true that part of the function of these stories is to explain features of life in the writer’s time. The Atrahasis Epic explains why some women are infertile, the Gilgamesh Epic why human beings are mortal, while Genesis justifies the origin of the Sabbath and explains why snakes bite and weeds grow. But these are features of modern origin stories too: how many times have we been told that a certain human or animal characteristic is explicable in terms of our evolutionary development! Indeed much history writing tends to explain the present by telling us what went on in the past. All the time we trace the successes or problems of our era back to what our ancestors did. So although the types of explanation in the ancient texts offered for present phenomena may differ from modern explanations, that does not justify the term myth being applied to them.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Even the incredible aspects of the stories are a poor reason for calling them myths. Modern stories of origin include elements that are in some ways even more astonishing than Methuselah living 969 years or the snake speaking. The idea that the whole cosmos came from an initial big hot bang of microscopic size blows the imagination. Elements in the theory of evolution, such as the origin of life or the eye, are also very difficult to ascribe to mere chance. But we accept these ideas because many eminent scientists affirm them. Doubtless there was a similar intellectual consensus in the ancient orient about their theories of origin, which these stories reflect. We do them an injustice if we call them myths, just because we find it difficult to believe all they affirm.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A careful reading of Genesis 1—11 gives us an insight into how the Israelites must have understood them. Genesis is built round a chain of genealogies. The first major one begins with Adam and ends ten generations later with Noah (Gen. 5). The next important one consists of ten generations from Shem to Abraham (Gen. 11:10–26). The stories about Abraham and his descendants must have been understood as historical: they deal with typical family problems, which every Israelite could identify with and indeed was expected to identify with because Abraham, Isaac and Jacob were his ancestors. But the genealogies show that this chain of historical individuals stretches back to the beginning of history.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Nevertheless, the first three chapters of Genesis do suggest that they are dealing with a different world from the present. Chapter 1, as we shall see below, is an overture to the whole book. The main storyline begins in 2:4, but the situation described in chapter 2 changes dramatically in chapter 3. The curses on the land, man, ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("woman and the snake describe life as it was for an Israelite in Bible times. Crops were hard to grow, women suffered pain in childbirth, and snakes bit humans. But chapter 2 describes a world without these woes: a garden with abundant fruit, no inhibitions spoiling male-female relationships, and no conflict between mankind and the animal kingdom. In other words chapter 2 is set in an era quite distinct from the historical period. What is more, chapter 3 ends with Adam and Eve being expelled from paradise and unable to return because of the cherubim wielding a flaming sword. In other words the garden of Eden is now somehow beyond the grasp of human beings.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Rogerson has well summed up how the first readers viewed these chapters. ‘For Israelites … the narratives of Genesis 1—11 were factually true, but Israelites did not expect to experience the things they describe. Adam and Eve were accepted as real human beings, but any Israelite woman who claimed that she had had a conversation with a snake would have been dismissed as a crank’ (Rogerson 1991, p. 54). Today’s readers still have a problem in defining them. The German term "), _c('i', [_vm._v("Urgeschichte")]), _vm._v(", that is Protohistory, is one option. Another possibility is ‘Origin Story’, the ancient equivalent of Darwin’s "), _c('i', [_vm._v("Origin of Species ")]), _vm._v("or Hawking’s "), _c('i', [_vm._v("A Brief History of Time")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("GENESIS’ TRANSFORMATION OF ORIENTAL ORIGIN STORIES ")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Comparison of Genesis 1—11 with other ancient Near Eastern origin stories not only clarifies its genre but sheds great light on their theological purpose. So far we have concentrated on the similarities between Genesis and these other stories from Mesopotamia to clarify their genre, but it is even more instructive for an understanding of Genesis to see how it differs from these earlier accounts.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("There are quite a number of differences that are probably not very significant. For example, in the Gilgamesh account of the flood, Atrahasis (Ut-Napishtim) builds a seven-decked cube as an ark, whereas Noah’s is more like a supertanker. In Gilgamesh the destructive phase of the flood lasts seven days, whereas in Genesis it lasts 40. After the flood Atrahasis sends out a dove, a swallow and a raven, whereas Noah sends out a raven and a dove. There are many other differences of this sort between the biblical and other versions. This makes it virtually certain that the author of Genesis did not know these other texts in the versions we possess. Rather, these stories circulated in the ancient world in different versions, oral and written. Most people then knew the story of the flood even though they had not read or heard the Atrahasis or Gilgamesh epics, just as people today know about evolution without having read Darwin.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What we have in Genesis is a major "), _c('i', [_vm._v("theological ")]), _vm._v("reinterpretation of traditional origin stories. Throughout the ancient Near East people believed in a multitude of gods and goddesses: they were polytheists. This is reflected in all the Mesopotamian tales we have considered.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("But in GeneBut in Genesis there is but one supreme God, who creates everything and controls everything. The Atrahasis epic tells of the lesser gods going on strike against the higher gods, and the higher gods are divided among themselves: that is why Ea (Enki) tips off Atrahasis about the flood. We read of the gods cowering like dogs at the flood they have released, whereas at the height of the flood ‘God remembered Noah’ and immediately the waters start to subside. Whereas the Babylonian gods cannot control the flood, the God of Genesis can. The biblical insistence on the unity and sovereignty of the one God is clearest in Genesis 1. There he speaks and, stage by stage, the world is brought into existence. In oriental thought the sun and the moon were important gods, but Genesis affirms they were simply created by God on the fourth day.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Strikingly different is Genesis’ portrayal of God’s attitude to man from that in the other texts. According to the Atrahasis epic mankind was created as an afterthought to break the strike called by the lesser gods and to supply food to the gods through the offering of sacrifice. But in Genesis 1 the creation of man constitutes the climax of the creation story: created in God’s image human beings are God’s representatives on earth. Far from man supplying God with food, it is God who supplies man with food.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As far as the Babylonian world-view was concerned one of the big problems with humanity was its fertility. The population explosion disturbed the rest of the gods: three times they tried to control it by plague, drought and famine before they resorted to the flood. Then after the flood they resorted to disrupting the reproductive process by making some women infertile, letting children die young and assigning other women to celibacy. Genesis has a very different perspective. From the start God blesses mankind and encourages procreation with the words ‘Be fruitful and multiply’ (Gen. 1:28). After the flood the same command is given to Noah, not once but three times (8:17; 9:1, 7).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When it comes to morality the Babylonian deities do not appear to be paragons of virtue. They squabble among themselves, and are not averse to deceiving each other or humans. The flood as we have seen was sent not because of human sin as in Genesis, but simply because there were too many people around. Atrahasis escaped because he worshipped Ea, who did not approve of the flood, whereas Noah escaped because of his exemplary behaviour. ‘Noah was a righteous man, blameless in his generation’ (6:9).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Thus as Genesis retells familiar oriental stories about the origins of the world, it dramatically transforms them theologically. Polytheism is replaced by monotheism, divine weakness by almighty power. Human beings are no longer seen as a sideline but central to the divine purpose. God looks after man by supplying him with food, not the other way round. Finally, the God of Genesis is very concerned about human sin: it was this that prompted him to send the flood, not population growth.")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('div', {
    staticClass: "fig",
    attrs: {
      "id": "p33"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 1: ",
      "src": "images/p33.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Figure 1: "), _c('b', [_vm._v("ZIGGURAT")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig_source"
  }, [_vm._v("Taken from p. 109 of the "), _c('i', [_vm._v("New Bible Dictionary")]), _vm._v(", Downers Grove: IVP, 1996.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("But there is more to Genesis’ retelling of tradition than a piecemeal rejection of certain theological ideas: Genesis has a quite different view of the direction of history. For example, the Sumerian flood story ‘takes throughout an affirmative and optimistic view of existence: it believes in progress. Things were not nearly as good to begin with as they have become since … In the biblical account it is the other way around. Things began as perfect from God’s hand and grew then steadily worse through man’s sinfulness until God finally had to do away with all mankind except for the pious Noah who would beget a new and better stock’ ( Jacobsen 1981, p. 529).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("This challenge to the optimism of the Babylonian world reaches its climax in the tower of Babel (Babylon) story in Genesis ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("11. Babel in Akkadian means ‘Gate of God’: the Babylonians held not only that Babylon was the centre of civilization but that its Ziggurat temple was the gateway to heaven, indeed that its top reached the heaven. Genesis ridicules this idea suggesting that Babel means ‘confusion’ or ‘folly’. And so far from the temple touching heaven, God had to come down from heaven to be able to see it!")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-004"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("RETELLING MODERN COSMOLOGY THEOLOGICALLY")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The ancient Near East told its story of origins by explaining what happened in the past as the result of the action of numerous gods. Genesis explains everything by reference to the will of one supreme and moral God.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Today’s stories of origins, such as the big-bang cosmology and the theory of evolution, see all change as caused by scientific law and chance. How would you retell these stories bringing God into the picture? What sort of a God emerges if you posit that he controlled all that happened in the formation of our universe and still is in charge today?")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-020"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("THE ORGANIZATION OF GENESIS 1—11")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The arrangement of Genesis into chapters is quite a late development (see previous chapter) and sometimes these chapter divisions do not occur at the right places. The book itself has its own system of internal titles or headings, usually translated ‘These are the generations/ descendants of ’. There are ten of these titles, one of which (36:1) is duplicated in 36:9. Sometimes this title introduces a long narrative, at others a short genealogy. The table below sets out")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("the data.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Except in 5:1 the Hebrew phraseology of these titles is the same. The person named in the title is the senior figure in the narrative that follows. From the named person his descendants come and usually fill the stage of the ensuing section. This is clearest in the case of Isaac. He is alive throughout Genesis 25—35 and notionally at least head of the family, but his sons Jacob and Esau are the main actors in the story. Similarly from Genesis 37 to 50 Jacob is head of the family, but the main drama revolves around his sons. Probably the aptest ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("translation of the titles would be: ‘This is the family history of Noah/ Sons of Noah/Shem/Terah/Ishmael/ Isaac/Esau/Jacob.’")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-003"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("INTERNAL TITLES IN THE BOOK OF GENESIS")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "17%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "41%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Title")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Subsequent Content")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("2:4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of the heavens and the earth")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The story of Adam and his descendants 2:4—4:26")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("5:1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("This is the book of the generations of Adam")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Genealogy from Adam to Noah 5:1—6:8")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("6:9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of Noah")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Story of flood 6:9—9:29")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("10:1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of the sons of Noah")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Table of nations descended from Noah 10:1—11:9")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("11:10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of Shem")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Genealogy from Shem to Abraham 11:10–26")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("11:27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of Terah")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Story of Abraham 11:27—25:11")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("25:12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of Ishmael")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Genealogy of Ishmael 25:12–18")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("25:19")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of Isaac")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Story of Jacob and Esau 25:19—35:29")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("36:1, 9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of Esau")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Genealogy of Esau 36:1—37:1")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("37:2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These are the generations of Jacob")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Story of Joseph and his brothers 37:2—50:26")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The distribution of titles shows that Genesis 2—50 falls into two main sections: 2:4—11:26 and 11:27—50:26. Both sections contain three narrative sections and two genealogies. This is significant, for it shows that essentially the first section anticipates the second, so that we cannot really understand the opening chapters without understanding the later chapters and "), _c('i', [_vm._v("vice versa")]), _vm._v(". It enhances the case we made earlier for holding that the readers of Genesis would have regarded the people mentioned in Genesis 1—11 as just as real as those in chapter 12 onwards. It also shows that to understand the opening chapters of Genesis, we must read them not simply as commenting on and modifying ancient oriental ideas, but also introducing the main plot in chapters 12—50.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Conspicuously outside the scheme of titles is the first chapter of Genesis (more exactly 1:1—2:3). This account of creation in six days followed by the first Sabbath is an introduction to the whole book. It stands as ‘a majestic festive overture’ to Genesis, indeed to the whole Bible. Like an overture to an opera it introduces tunes and motifs that will be important in the following work. Here key ideas about God and his relationship with man that will be important in the succeeding chapters are introduced for the first time. These ideas are refined and developed in the next ten chapters, so that 2:4 to 11:26 constitute as it were a second exposition to the book, with the main storyline taking off in 11:27 with the birth of Abraham.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("1:1—2:3: The first exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In its very first words Genesis asserts God’s absolute power. ‘In the beginning God created heaven and earth’ i.e. everything. But to start with the earth was shrouded in darkness and covered with water.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As soon as God speaks this dark chaos is turned to order. On the first day he says: ‘Let there be light’; and there was light. On the third: ‘Let the dry land appear.’ And it was so. God’s acts of creation in the second half of the week echo those in the first half, so that there is a correspondence between the first three days and the second three days.")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-004"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("CREATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "btop bleft",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Day 1 ")]), _vm._v("Light")])]), _vm._v(" "), _c('td', {
    staticClass: "btop bleft bright",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Day 4 ")]), _vm._v("Sun, moon and stars")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "btop bleft",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Day 2 ")]), _vm._v("Sky")])]), _vm._v(" "), _c('td', {
    staticClass: "btop bleft bright",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Day 5 ")]), _vm._v("Birds (and fish)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "btop bleft btom",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Day 3 ")]), _vm._v("Land and")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("plants")])]), _vm._v(" "), _c('td', {
    staticClass: "btop bleft btom bright",
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Day 6")]), _vm._v(" Animals and man; plants for food")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    staticClass: "btom bleft bright",
    staticStyle: {
      "border-right": "#FFF"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Day 7")])])]), _c('td', {
    staticClass: "btom bleft bright",
    staticStyle: {
      "border-left": "#FFF"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Sabbath")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })])])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("This structuring of Genesis into a week of seven days is only one of a series of recurring formulae that run through this chapter, such as ‘And God said’, ‘And it was so’, ‘God saw that it was good’ or ‘God blessed’. But though these formulae recur, they are not repeated mechanically, so that on some days a formula may appear once, on others twice, and sometimes it is ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("omitted. This creates a rich and interesting tapestry subtly indicating which acts of creation are most significant.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-005"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("SIGNIFICANT DAYS IN GENESIS 1")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Which days of creation are described at most length? Which days mention God speaking twice ‘and God said’ and have the approval formula ‘God saw that it was good’ twice? How would you explain this?")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Genesis 1 thus presents God as a God of power and order. He only has to speak and it happens. This is quite unlike other accounts of creation from the ancient orient, such as Enuma Elish, where the gods fight to achieve supremacy over each other and creation. The God introduced in Genesis 1 is absolutely sovereign. He created the sun and the moon: they were not rival deities as was often believed. It is this God who can do what he says, who makes the promises to the patriarchs that are central to the whole Pentateuch.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Genesis 1 not only asserts the sovereign power of God the creator, it affirms the centrality of mankind in the divine plan. Unlike the Atrahasis epic where man’s creation is an afterthought of the hungry gods, the whole of Genesis 1 builds towards the action on the sixth day. The creation of the land and plants on the third day and the creation of the sun and moon on the fourth, which are so important for human life, are described more fully than other days. It is only when man has been made that ‘God saw all that he had made, and behold, it was very good.’")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The creation of man is heralded by the divine invitation to the angels or other members of the Trinity, ‘Let us make man in our image’, in other words to make a creature who will be God’s representative on earth. Other oriental peoples believed that kings were made in the divine image, but Genesis affirms that every human being is made in God’s image. ‘So God created man in his own image … male and female he created them’ (Gen. 1:27). Again contradicting the Atrahasis epic, God blessed them and said to them, ‘Be fruitful and multiply’.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-006"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("GENESIS AND ECOLOGY")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("God’s first commands to the human race ‘Be fruitful and multiply, and fill the earth and subdue it; and have dominion over the fish of the sea and over the birds of the air and over every living thing’, have sometimes been taken as sanctioning unbridled exploitation of the rest of creation. But this is to forget that humanity is made in God’s image to be his representative on earth, that is, to act in a godlike way in caring for the earth and the other creatures in it. Kings in ancient times were expected to rule their people in a way that benefited their subjects and in particular kings had a duty to look after the poor and weak members of their realm. It is this language that Genesis is echoing here. Or to put it another way, humanity is expected to manage the earth for God in a way that pleases him.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The creation of man in God’s image may be the climax of creation, but it is not the goal of creation. That is the seventh day, the day when ‘God rested from all his work that he had done in creation’ (Gen. 2:3). By implication man, who is made in God’s image, should also rest on the seventh day. In other words Genesis, like the Ten Commandments (Exod. 20:11), traces the origin of the Sabbath back to creation. It is also, as Jesus says, made for man’s benefit (Mark 2:27).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This opening chapter of Genesis is most important for understanding some of the writer’s fundamental principles. Here he sets out ideas that are assumed in the rest of the book, such as the unity and power of God, his concern for human welfare, and the lifestyle that is best for human beings. It portrays a world of harmony, in which animals do not attack each other or men attack animals, for all are vegetarian (1:29–30). Rather, mankind as God’s image bearer represents him on earth and manages the world for the benefit of all. These same ideals are visible in chapter 2, but then they break down in chapter 3 following. But they are not forgotten: they are still the yardstick by which the writer evaluates action and the ideals which one day he hopes will be realized in the promised land (see Gen. 49; Deut. 33).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("2:4—11:26: The second exposition")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Genesis 2—11 consists of five distinct sections, each headed by the title ‘These are the generations’, or as the title would be better translated ‘This is the family history of ’. They constitute a second exposition, for they elaborate the basic principles set out in the first chapter of the book.")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-005"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("2:4—4:26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The history of heaven and earth")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("5:1—6:8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The family history of Adam")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("6:9—9:29")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The family history of Noah")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("10:1—11:9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The family history of Noah’s sons")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("11:10–26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The family history of Shem")])])])])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The longest of these family histories is the middle one, the story of the flood and its aftermath. Its fullness is a mark of its importance in the story. Just as in Mesopotamian accounts the flood divides world history into two eras, in Genesis the flood is seen as a great act of decreation: the world returns to its original state as described in Genesis 1:2, with water covering the surface of the earth. Nearly everything created in Genesis 1 disappears, land, plants, animals and man. The only survivors are to be found in the ark. But decreation is followed by recreation. When ‘God remembered Noah’ (Gen. 8:1), the wind blew (cf. Gen. 1:2) and everything started to reappear: outside the ark the land and the plants again became visible and, when Noah and the animals disembarked, the animal world started to be replenished. Noah himself is seen as a second Adam figure. He, like Adam, is viewed as the ancestor of all mankind, and like Adam he was told to be fruitful and multiply. Like Adam he cultivated fruit trees, in Noah’s case vines. Adam ate a forbidden fruit, but Noah consumed too much wine, dishonoured himself and was further shamed by his son. So in a sense mankind fell again. Thus this central section is not only structurally important, but it is theologically significant too. ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Each section is not only headed by its own title but typically concludes with a trailer for the next section, a few verses that sum up or introduce the next section. Thus 4:25–26 is a trailer for the genealogy of Adam in chapter 5. Genesis 6:5–8 sums up God’s reasons for sending the flood, the topic of the next three chapters. Noah’s blessing and curse of his sons in 9:25–27 explains the table of nations in chapter 10. Finally the birth of Abram in 11:26 introduces the Abraham stories, which begin in 11:27.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("2:4—4:26")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This section, called in the Hebrew ‘the history of the heaven and earth’, consists of two parts:")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-006"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("2:4—3:24")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The Garden of Eden")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("4:1–26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Cain and his descendants")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These two parts are not just linked by sequence: Cain is Adam’s son, but he also sins in worse ways than his father Adam. The second part about Cain deliberately echoes the first part about Adam to show how much more Cain has degenerated than his father.")]), _vm._v(" "), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-007"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("ADAM AND CAIN: DEEDS, WORDS AND CHARACTER")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Compare Adam’s deeds and dialogue with God (Gen. 3:6–12) with Cain’s (4:8–15). In what way does Cain appear to be a worse sinner than his father?")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Garden of Eden story falls into parts: 2:4–25 describes life in the garden before the act of disobedience, while chapter 3 describes the deed and its consequences culminating in expulsion from the garden. Chapter 2 takes up motifs already addressed in chapter 1 but discusses them in greater detail: chapter 1 gives a panoramic view on the whole of creation, but 2:4–25 zooms in with a close-up on the creation of man and woman. Chapter 1 ended with the creation of mankind in two sexes to rule the rest of creation and supplied by God with food. In reverse order these three topics, food, dominion and sexuality, are the central topics of chapters 2 to 3. First, reinforcing the message of chapter 1 that God feeds man, not man the gods, as Babylonians held, God’s rich provision of fruit trees in the garden is noted (2:8–17). Second, man’s rule over the animals is reaffirmed by them coming to Adam to be named (2:18–20). It should be noted that the animals are viewed as potential companions for Adam: there is no suggestion that they are a danger to him or that he will exploit them. Finally, God creates Eve from Adam’s rib and introduces her to him in an archetypal wedding ceremony (2:21–25). This episode expresses in story-form some of the book’s convictions about relations between the sexes, which are alluded to in 2:24–25.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The location of the garden is tantalizing. Because the Tigris and Euphrates are fed by the river of Eden it might be surmised that Eden was located somewhere in the North, where these rivers rise. But on the other hand 3:24 tells us that no one can enter the garden because it is guarded by the cherubim. This suggests that somehow the garden is real but inaccessible to man.")])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('p', {
    staticClass: "enc_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Digging deeper:")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("THE SYMBOLISM OF EVE")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Assuming that an all-powerful and all-generous God could have created more beings out of Adam’s rib than just Eve, why did he create just one woman? Does this reflect biblical ideas about sexual relationships? Is there symbolic significance in making Eve out of a rib rather than some other body part?")])])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The symbolism of Eden is clearer than its location. Eden means ‘delight’, and it is portrayed like a beautiful paradise island with abundant water and delicious fruits. What is more, it had lots of gold and precious stones: even God enjoyed strolling through its leafy trees. Later in the Bible this imagery is used to describe the tent shrine called the tabernacle (Exod. 25—40) and the temple in Jerusalem. All the symbolism, such as water and gold, contributes to making the point that this garden and the later temple are where God dwells, the God who gives life to all creation.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Chapter 3 shows how all the pleasures of Eden were lost by the woman picking the only forbidden fruit and the man eating it. Immediately the intimacy between them (2:25) was shattered: guilt-ridden they hid in the trees and made clothes out of fig- leaves, and when challenged by God lame each other for their sin (3:6–13). But the longer-term consequences are graver still. Harmony between man and the animals is replaced by perpetual conflict (3:15). The woman’s role as wife and mother is to be marred by tension and painful childbirth (3:16), while the man’s task as keeper of the garden is from now on to be characterized by hard frustrating toil, and eventual death (3:17–19). Whereas Babylonian tradition held universal death originated after the flood, Genesis traces it back to the first human couple. Finally, both were expelled from Eden, the dwelling place of God and source of life. In this way the threat ‘in the day that you eat of it you shall surely die’ (2:17) was carried out.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("These punishments, or curses as the text calls them, describe the problems faced by ancient Israelites, and to a greater or lesser extent every human being. Life was ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("precarious in Bible times for the average peasant farmer. Crops were hard to grow and prone to fail in times of drought, while wild animals including snakes endangered human life. Death, pain and conflicts between man and wife were not unknown either. These universal human problems are the more poignant after the idyllic way of life described in chapter 2, which remained the dream that the Old Testament hoped one day would again be realized (see Amos 9:13–15; Isa. 11:6–9).")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-009"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("What do you think?")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("THE PROTEVANGELIUM")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Genesis 3:15 ‘He shall bruise your head and you shall bruise his heel’ predicts ongoing hostility between man and snakes. It is thus an etiology (explanation) of this phenomenon. Some commentators have seen it as nothing more.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("However from at least the third century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" Jews, and subsequently Christians, have seen this as a prediction of the Messiah who would be victorious over the powers of evil. It is therefore called the Protevangelium (first gospel).")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("However, chapter 4, the story of Cain and his descendants, paints a picture of further deterioration. For the first time in the OT the most important topic of sacrifice is raised. Whereas Abel offers the best of his flock, ‘the firstborn’, Cain merely offers some of his produce. Only the best is good enough in sacrifice, so not surprisingly Cain’s was rejected. But instead of mending his ways, Cain killed his brother. Murder is bad enough, but to kill your own brother is worse still, for brothers are specially responsible for their mutual well- being. Cheekily Cain brushed off God’s enquiry about Abel with what sounds like a joke: ‘Am I my brother’s keeper?’ The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" was not fooled and he sentenced Cain to a life of perpetual nomadism. As mentioned earlier, this looks like a reversal of Nintur’s attempt to rescue primeval man from his original nomadic way of life.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Further points of contact with Sumerian traditions have already been noted in 4:17–18, 26 (see above, p. 11). Other traditions may lie behind 4:20–22, which list the inventors of various arts and crafts, who were descended from Cain.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Mesopotamian tradition told of seven sages who were sent by the god Ea to teach mankind the arts of civilization. Here they are merely human achievements shadowed by the violence of Cain and his even more vicious descendant Lamech (4:18, 23–24).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("5:1— 6:8")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This section entitled in the Hebrew ‘the book of the family history of Adam’ consists of three sections:")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-007"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("5:1–32")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Genealogy of Adam to Noah")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("6:1–4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("‘The sons of God’ episode")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("6:5–8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Trailer for the flood")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We have already noted that in certain respects the genealogy in Genesis 5 corresponds to the antediluvian section of the Sumerian King List, which lists eight, nine or ten kings who reigned before the flood. Genesis has ten generations from Adam to Noah.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Some commentators have supposed that this genealogy of Adam to Noah is a variant of the genealogy of Adam to Lamech in Genesis 4. They point out that some of the names are the same, Adam, Enoch and Lamech, and others are somewhat similar, e.g. Methushael and Methuselah, Irad and Jared. On closer inspection the two genealogies do not seem to be alternative versions of the same line.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("First, it should be noted that the similar- looking names do not come in the same order. Second that the similar-looking names are actually more different in the Hebrew than in their English forms:")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-008"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("GENEALOGIES OF ADAM TO NOAH")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Genesis 4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Additional Comments")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Genesis 5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Additional Comments")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Names")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Names")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Adam")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Adam")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Cain")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Seth")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Enoch")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Named a city")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Enosh")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Irad")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Kenan")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Mehujael")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Mahalel")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Methushael")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Jared")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Lamech")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Had two wives")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Enoch")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Walked with God")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Methuselah")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Lamech")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Prayed for relief from the curse")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Noah")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Hebrew speakers would not have identified them. Finally, the identical names (Enoch and Lamech) are carefully distinguished in both lists by comments to prevent them being confused. This makes it plain that the writer of Genesis saw these genealogies as quite distinct. Later in Genesis the family history of the non-elect line (e.g. Ishmael (25:12–18) or Esau (36:1—37:1)) precedes that of the chosen line (e.g. Isaac (25:19—35:29) or Jacob (37:2—50:26). The arrangement here is similar: the genealogy of the wicked Cainites precedes that of the chosen Sethites, whose line contains saints like Enoch and Noah.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The four verses 6:1–4 about the sons of God marrying the daughters of men are probably the most problematic in the whole of Genesis. Much discussion is found in the commentaries about the identity of the sons of God and the nature of their sin. Four main interpretations have been advocated. 1) The sons of God are kings, who have large harems in their courts. 2) The sons of God are the sons of Seth who intermarried with the daughters of Cain (men). 3) The sons of God are the sons of Cain who married the daughters of Seth (men). Both explanations 2 and 3 see the problem as essentially godly humans (sons of God) marrying ungodly humans (daughters of men). The interpretations disagree whether the descendants of Cain or the descendants of Seth are the godly line. 4) The sons of God are spirits/angels/ demons/minor gods who married human girls (daughters of men).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Extraordinary as the last suggestion seems to modern secular readers, it is the interpretation that takes the key terms ‘sons of the gods/God’ and ‘daughters of men’ in their most natural sense. (For another picture of the divine council of which the sons of the gods were members see Job 1:6–12.) This meaning of the phrase ‘sons of the gods’ is known in Canaanite literature. It is also the understanding of the oldest Jewish writers, the New Testament (2 Peter 2:4; Jude 6, 7), and early Christian writers.")])]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-010"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "enc_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Digging deeper:")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("DID METHUSELAH REALLY LIVE 969 YEARS?")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The ages at which the men listed in Genesis died or even had their first child are astonishing to say the least. Since it is hard to take them literally, there have been a variety of attempts to explain these ages. Could their years have been much shorter, e.g. just a month? Though this would make their ages at death more reasonable, they would then have been rather young to father their children!")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Another suggestion is that each figure represents a dynasty and that many generations have been omitted. This breaks down where it can be tested, i.e. at the beginning or end of the genealogy, where Seth is clearly the son of Adam and Noah is the immediate descendant of Lamech. Another possibility mooted is that the ages are related to astronomical periods, e.g. Enoch’s 365 years correspond to the days in the solar year. Not all the figures are explicable so easily, nor is it clear why anyone should want to equate their ages to obscure astronomical data.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the light of the Sumerian King List, which makes the first king reign 28,800 years and his seven successors another 30,000 years each approximately, the Genesis figures look quite modest! Indeed, according to the Lagash King List babies were kept in nappies till they were 100 years old. So the heroes of Genesis matured quite quickly to procreate their first child at 130 years (Adam) or 70 (Kenan)! It therefore seems likely that in antiquity it was believed people matured slowly and lived to a great age. We could see Genesis 5 as a step from the impossible figures of Mesopotamia towards reality.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("However, this observation still does not explain the exact figures in either Sumerian or biblical texts. It has been suggested that many of these ages can be easily generated by formulae familiar to Babylonian mathematicians. They used a sexagesimal system, and liked calculating numbers using the factors of 60. Thus Adam’s ages, 130 and 930, may be easily produced by manipulating factors of 60. 130 = 2 x 60 + 10 (factor of 60). 930 = 30"), _c('sup', [_vm._v("2 ")]), _vm._v("+ 30.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This is intriguing, but we are still left to wonder what was the point of generating such numbers. Could they just be a way of telling us that real people, who had names, lived, procreated and died a very long time ago?")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For further discussion see Young (1988) and Wenham (1987, pp. 133–34).")])])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("So much is relatively clear, but what practices are being referred to that")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v(" provoked such a strong divine reaction? Clearly these ‘marriages’ between the sons of the gods and human girls were the last straw in God’s eyes. Next came the flood. The one suggestion that makes sense here can be advanced only tentatively. The ancient world believed that from time to time ‘divine beings’, ‘gods’, mated with humans to produce supermen like Gilgamesh, whose father was a priest and whose mother was the goddess Ninsun.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These creatures may be the Nephilim of 6:4. Furthermore, in the fertility cults of both Canaan and Babylon the practice of sacred prostitution was very important. Men went to the temple and had sexual intercourse with the god(dess). This was believed to promote fertility among ordinary women and good crops on the land. But it of course involved making girls into prostitutes. We therefore could read Genesis 6:1–4 as an outspoken attack on these ideas: far from sacred prostitution enhancing human and agricultural fertility it led to the flood and the near extinction of the race.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As already observed, 6:5–8 is a typical trailer with which major sections of Genesis end. While rounding off one section it introduces the theme of the next, which is the flood. The most damning judgement on human behaviour in the Bible (6:5) introduces God’s decision to destroy mankind (6:7). Already here we see Genesis starting to contradict the usual oriental view that the gods destroyed man because he was too noisy: it was because of his incorrigible wickedness. The nature of this wickedness is explained further in 6:11–13. Finally at the last minute God’s favourable attitude towards Noah is mentioned, but again it is Noah’s blameless behaviour that allows him to escape, not capricious divine favouritism as in other accounts (6:9).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("6:9—9:29")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The family history of Noah is the longest of the five sections that make up the second exposition, and we have already discussed its relationship to other oriental flood stories, its probable dependence on oral tradition akin to but not identical with Mesopotamian versions, and its theological transformation of these accounts to show the uniqueness, morality and power of the one God. So here we shall focus on other issues, such as the structure of the narrative, the reason for the flood, and how the earth is protected from a similar future catastrophe.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The flood story is the central section of the five sections that make up the second exposition (Gen. 2:4—11:26) and carefully organized in its own right. As a result of the flood the old world is destroyed, but as the waters retreat the earth is recreated. Both the destruction and recreation echo the opening chapters of the book to make these points clear (e.g. 7:14 cf. 1:21–25; 9:6–7 cf. 1:27–28). Noah is seen as a second Adam, the second father of the human race.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The turning point in the story is 8:1 ‘But God remembered Noah’. When God remembers people in the Bible, he also acts (cf. Gen. 30:22). So now he sends a wind to make the waters retreat (cf. 1:2). The whole story is told symmetrically, for ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("the action is fairly symmetrical. Noah goes "), _c('i', [_vm._v("into ")]), _vm._v("the ark at the beginning of the story, and comes "), _c('i', [_vm._v("out ")]), _vm._v("at the end. The mountains are "), _c('i', [_vm._v("covered ")]), _vm._v("by water as the flood rises, and are "), _c('i', [_vm._v("uncovered ")]), _vm._v("as the waters fall. This arrangement of topics in which the second half reverses the order of the first half (ABBA) is called chiasmus, or when there are many more than four topics, a palistrophe. The flood story is probably the most elaborate palistrophe in the Bible, with up to 15 elements both sides of the key statement ‘God remembered Noah’, emphatically reminding us of the main point of the story, that God was in control of the flood and deliberately saved Noah.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-011"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("FIND THE PALISTROPHE")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("See how many items in the flood story you can find that fit into a palistrophe, beginning at 6:10 and ending at 9:19. Names and numbers as well as actions may form part of the palistrophe.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Though the focus of the flood story is on salvation, God’s rescue of Noah because he was righteous, the scale of destruction is horrific. This is so, even if ‘the earth’ does not mean the whole planet, but all the land visible from somewhere in the Middle East. Genesis is therefore at great pains to justify why God should have taken such drastic action. It was not that he could not stand the noise of human beings, as Mesopotamian stories said. It was much more serious. Genesis offers two main reasons for God sending the flood, the perversity of human thought (6:5) and the violence of all creatures especially man (6:11–13). By prefacing the whole account with the story of the sons of the gods mating with human women, it implies yet a third reason, cult prostitution.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We have already discussed the last point, so just a little ought to be said about the others. Genesis 6:5 is the most shocking statement about human sinfulness in the whole Bible: ‘Every intention of the thoughts of his [man’s] heart was only evil continually.’ In the Old Testament the heart is not just the seat of the emotions, but of the mind and the will. The thoughts that emanate from the heart may not be as bad as they could be, but according to this verse they tend always towards evil. (For Jesus’ similar assessment cf. Mark 7:21–23.) No wonder God was disappointed with his creature, whom Genesis 1 sees as the climax of the creation. Disappointment is too mild a description: ‘it grieved him to his heart.’ This is the bitter indignation felt by Dinah’s brothers when they were told of her rape, or David’s grief over the death of Absalom, or a deserted wife (Genesis 34:7; 2 Samuel 19:2; Isaiah 54:6).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("It was not just that human thought tended inexorably towards evil; it led to the earth being full of violence. Soon after Adam had been evicted from Eden, his son Cain murdered his brother out of jealousy. A few generations later Lamech promises seventy-sevenfold vengeance on anyone who attacks him. In this way Genesis traces violence back to the first days of human history. Furthermore it implies ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("that before the flood human violence had spread to the animal kingdom, for ‘all flesh’, that is man and beast, ‘had corrupted their way on the earth … for the earth is filled with violence through them’(Gen. 6:12–13). Genesis thus suggests God had three major reasons for sending the flood: misguided worship involving cult prostitution, the perversity of human thought, and universal violence. Noah, however, escaped because he was righteous, ‘blameless in his generation’ (6:9).")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The flood itself is a great act of decreation. Not only is human and animal life destroyed, but the mountains and trees are covered, so that the earth returns to the watery chaos described in Genesis 1:2. Even the chronology of the flood, which is extraordinarily precise, seems to underline this reversal, for just as the original creation started on a Sunday and ended on a Friday, so did the first destructive phase of the flood, which lasted 40 days (Wenham 1987, pp. 180–81). But when God remembered Noah, a new process of creation begins. Whereas the original creation took six days, recreation takes nearly a year. As before, the wind blows, the dry land and plants appear, and the earth is repopulated by man and the animals. As before, they are both told to be fruitful and multiply.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("But is the new creation identical with the old? Has the flood really purified the earth, or are the old problems of human perversity and violence going to rear their head again?")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As soon as Noah has disembarked, the narrative addresses these very questions. Noah built an altar, offered sacrifice, and when God smelled it, he said: ‘I will never again curse the ground because of man, for the intention of man’s heart is evil from his youth’ (8:21). The reason given here for "), _c('i', [_vm._v("not ")]), _vm._v("sending another flood is astonishingly similar to the reason given "), _c('i', [_vm._v("for ")]), _vm._v("sending the flood in the first place (6:5). How does one explain the divine U- turn? The slightly milder language in 8:21 is probably not significant: man’s thought is still inveterately sinful ‘from his youth’. The text ascribes God’s change of heart to Noah’s sacrifice ‘When the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" smelled the pleasing [better ‘soothing’] aroma, he said in his heart …’ Once again (cf. 4:3–6) Genesis makes a point about sacrifice through a narrative: here it illustrates how a righteous man’s sacrifice can atone for the sins of others, in this case the sins of the whole human race (cf. Job 42:8).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("But if man’s thoughts are just as sinful as they were before, is not violence still likely to be a problem? This issue is addressed in 9:1–7. It begins with a very clear echo of 1:28: ‘And God blessed Noah and his sons and said to them, “Be fruitful and multiply and fill the earth” ’ (9:1). This underlines the parallel between the first creation described in Genesis 1 and the recreation of Genesis 8—9. But from this point on Genesis 9 deliberately contrasts the new post-flood situation and the original creation as the following table shows.")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-009"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("CREATION BEFORE AND AFTER THE FLOOD")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "7",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Topic")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("Original Creation")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("New Creation after the Flood")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Human–animal relationships")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Under human control 1:28")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("In fear and dread of man 9:2")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Permitted food")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Only plants 1:29–30")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Plants and meat without blood 9:3–4")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Image of God")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("1:26–27 (No consequences stated)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Image of God means murder deserves exact retribution 9:5–6")])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-012"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("WAS THERE A UNIVERSAL FLOOD?")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Stories about a great flood are found among many peoples in many parts of the world. This has led archaeologists and historians of early man to search for traces of the flood in the ground. For many centuries it was believed that fossils were evidence for a universal flood, since they were found in so many places even on mountains. But as modern geology developed it became apparent that they were deposited millions of years before man existed.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("With the discovery of the Gilgamesh epic archaeologists supposed that a flood in Mesopotamia, where the epic was told, might lie behind the story. In the early twentieth century traces of severe flooding were indeed found at several sites in southern Iraq dating from about 3000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". However, closer investigation showed that these floods were not simultaneous, but happened at different times. Nevertheless some people think a local flood in Mesopotamia could have been the basis of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Another possibility is that the flood story reflects the heavy rains and flooding that marked the end of the last ice age about 10,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". At that time the melting of the ice led to the oceans rising some 120 metres (400 feet), which would have led to vast tracts of land being inundated, perhaps an area equal to the continents of North and South America together!")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Recently it has been discovered that the Black Sea basin was filled by a cataclysmic flood pouring in from the Mediterranean, when the land dam, situated where the straits of the Bosphorus are now, broke in about 5000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". In a very short time the villages around the shore of the sea were flooded and doubtless many died. Some may have escaped by boat.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Obviously none of these limited floods quite fits the traditional picture of a worldwide flood. Yet someone caught up in a flood might see water stretching as far as the eye could see and thus describe it in universal terms. But as we have suggested above, the theological significance of the flood is more important than its date or extent.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("From this table it is clear that Genesis 1 envisages a world of harmony. Animals do not attack each other or human beings, nor do humans kill each other or eat animals. But the experiences of Genesis 4—6 have shown that this is a forlorn hope, so chapter 9 lays down principles to stop violence getting out of hand again. Man’s supremacy over the beasts is reasserted, but the benevolent management envisaged by 1:28 is replaced by fear and dread, terms more characteristic of war than peace. The primal vegetarianism of 1:29 is replaced by permission to eat meat, as long as the principle of life is respected by not consuming the blood of the animal (9:3–4). Finally the uniqueness of human life is to be protected by exact retribution: whoever or whatever kills a man must be put to death (9:5–6). This resort to the death penalty contrasts with the sevenfold or seventy-sevenfold vengeance demanded by Cain and Lamech (4:24). It expresses a central principle of Old Testament justice that the punishment should match the crime and aims to stop a blood feud developing in which the families of both sides keep on retaliating so that the initial death of one person leads to the death of many others.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The final episode (9:20–27) in the Noah story is surprising. It tells of Noah growing grapes, making wine, getting drunk and cursing his grandson Canaan for Ham’s tactlessness. Does this episode really belong here, and what does it contribute to the plot of Genesis?")]), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("There are good reasons for holding that it is not a stray insertion into the book. First, in Greek myths grape-growing and wine- making are traced back to the time of the flood. Second, the Sodom and Gomorrah story, the next narrative in Genesis dealing with a universal act of judgement and the salvation of one family, also ends with the righteous man getting drunk and being abused by his children (19:30–38). Finally, this episode here acts as a trailer for the next major section, the table of nations in chapter 10. We have noted this pattern before in Genesis e.g. 4:25–26; 6:5–8.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is the connection with chapter 10 that is the first clue to this episode’s purpose in Genesis. It demonstrates the correctness of Shem and Japheth’s behaviour over against Ham’s impropriety: in the ancient world at least children were expected to cover up their parents’ faults, not blab them abroad as Ham did. It was of course from Shem that Abraham and the Israelites were descended, but it was from Ham that Israel’s traditional enemies came, peoples such as Egypt, Assyria and Babylon. But worst of all from Genesis’ perspective were the Canaanites, the descendants of one of Ham’s sons. Noah’s curse on Canaan foreshadows the future subjugation of the Canaanites by the Israelites. In Noah’s words ‘Blessed be the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", the God of Shem; and let Canaan be his servant’ (9:26). So just as Adam had three sons, two good (Abel and Seth) and one wicked (Cain), Noah has three sons, two good and one wicked. In both cases Genesis traces the parting of the ways, showing how the chosen line through Abraham can be traced back through Shem and Seth.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("The parallels between Adam and Noah suggest another function of this story. ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Noah like Adam is seen as the ancestor of the whole human race, everyone else having perished in the flood. After the flood he was, like Adam, told to be fruitful and multiply. At the beginning of the story we are told, ‘Noah was a righteous man, blameless in his generation’, OT terminology for a top-quality saint! Furthermore, in the flood story he is repeatedly said to obey God exactly (6:22; 7:5, 9, 16; 8:18). Yet sometime later he acts in a way that reminds us again of Adam, who ate of a forbidden fruit. Is Noah’s over-consumption of the fruit of the vine a transgression akin to Adam’s? Is this a second fall as it were? Opinions differ. One thing is clear: Ham’s sin is obviously worse than his father’s, just as Cain’s murder was more serious than Adam’s action. What is more, the situation deteriorates further in both cases, culminating in the punishment of the flood in the first case, and the dispersal of the nations, after they had tried to build the tower of Babel, in the second case.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-013"
    }
  }, [_c('p', {
    staticClass: "enc_tit"
  }, [_c('span', [_vm._v("Digging deeper:")])]), _vm._v(" "), _c('p', {
    staticClass: "enc_stit"
  }, [_c('span', [_vm._v("NOAH’S DRUNKENNESS: DOES GENESIS THINK IT SINFUL?")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The answer given to this question determines whether Genesis 9:20–27 should be read as a second fall like Adam’s. Consider some other passages dealing with wine and other strong drinks. Is there a consistent attitude in them?")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Compare Psalm 104:15; Deuteronomy 14:26;")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Isaiah 5:1–7 with Numbers 6:3–4; 1 Samuel 1:14;")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Proverbs 21:17; 23:20–21, 29–35; Isaiah 5:22.")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("10:1—11:9")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The last major section consists of two very different pieces: the Table of Nations (10:1–32) and the Tower of Babel (11:1–9). On first reading they appear to offer contradictory explanations for the diversity of languages in the world, but they are both in the same part of Genesis headed by the title, ‘These are the generations of the sons of Noah.’")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Table of Nations lists seventy nations known to the Israelites and by implication defines Israel’s relationship to her neighbours. The sons of Japheth (vv. 2–5) seem to be the people on Israel’s northern horizon, inhabitants of Turkey, the Greek islands, Cyprus and Crete. The sons of Ham (vv. 6–20) are a large group, covering peoples from Africa, Arabia, Mesopotamia as well as the indigenous inhabitants of Canaan (vv. 15–19), whose territory would be promised to Abraham. As already mentioned, Israel did not enjoy good relations with the descendants of Ham. The opposite is true of the sons of Shem (vv. 21–31). Not only did Israel trace its own line through Shem (11:10–26), but it seems to have enjoyed friendly relations with many of the Arabian and Aramaean groups related to Shem.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Table of Nations regularly mentions that these different peoples spread out to their own territories and spoke their own languages without hinting that there was anything amiss (10:5, 20, 31, 32). But the Tower of Babel story puts a quite different spin on this dispersal. Babel is Babylon and in the local language meant ‘Gate of God’, in other words the entry to heaven.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Indeed the Babylonians claimed that their ziggurat, a sort of pyramid with a temple on top, had its foundations in the underworld while its top touched the heavens.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These pretensions are mercilessly sent up in this story. So far from its top reaching heaven, it was so low that God could hardly see it but had to come down to see what man was trying to do (11:5 cf. Isa. 40:22). The name Babel really means ‘Confusion’, and sounds like ‘Folly’. According to one Sumerian story everyone would one day speak Sumerian, but Genesis says that God deliberately made people speak different languages so that they could not work together on godless projects that aimed to enter heaven. The derelict ziggurat in Babylon and the multiplicity of languages witness to God’s judgement on human sin.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("At many earlier points in Genesis we noted that it seemed to be criticizing Babylonian notions about the gods, the role of man, the flood and so on. Here in chapter 11 the attack on the pretensions of Babylon is open and blatant. It is not the greatest civilization, nor is it the closest to God: rather its buildings are a reminder that the human race cannot reach heaven on its own, but stands under divine judgement.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("11:10–26")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The genealogy of Shem links the protohistory of Genesis 1—11 to the stories of the patriarchs in chapters 12—50. Like the earlier genealogy of Adam via Seth it consists of ten generations and traces the chosen line from Shem to Abraham. This time though the ages are considerably lower than in chapter 5, but still high by our standards. With this genealogy the second exposition of Genesis ends, and the main story is ready to unfold.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-030"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("THE NEW TESTAMENT USE OF GENESIS 1—11")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For the New Testament writers the opening chapters of Genesis are foundational to their theology. From John’s imitation of Genesis 1:1 in the opening lines of his Gospel ‘In the beginning was the Word and the Word was with God’ to the reversal of the confusion of languages on the day of Pentecost (Acts 2), the New Testament draws on nearly every element in these opening chapters. Luke uses the genealogies to trace Jesus’ line back to Adam to show that Jesus is the Son of God (Luke 3:23–38). Paul makes abundant use of the story of Adam and the fall to demonstrate that the obedience of Christ the second Adam saved mankind from the effects of the first Adam’s disobedience (Rom. 5). Jesus cites the creation stories to demonstrate his view of marriage over against the Pharisees and uses the flood as a warning of future judgement (Matt. 19:3–12; 24:37–39). Finally the book of Revelation portrays the new Jerusalem descending from heaven to earth as a Garden of Eden, a place where God himself dwells and gives life to the nations (Rev. 21—22).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Early Christian writers continued to draw heavily on these chapters in their works. ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Louth writes ‘the early chapters of Genesis had arguably a greater influence on the development of Christian theology than did any other part of the Old Testament’ (2001, p. xxxix). On the basis of these chapters they developed the insights of St Paul about Christ as the second Adam, the doctrine of creation, and particularly the implications of man being made in the image of God.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-031"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("FURTHER READING ")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("R. S. Hess and D. T. Tsumura "), _c('i', [_vm._v("I Studied Inscriptions from before the Flood")]), _vm._v(". Winona Lake: Eisenbrauns, 1994. A collection of the most useful modern essays on these chapters including Jacobsen.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A. Louth "), _c('i', [_vm._v("Genesis 1—11")]), _vm._v(". (Ancient Christian Commentary on Scripture.) Downers Grove: InterVarsity Press, 2001. Shows how Christian writers up to the eighth century understood Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("G. von Rad "), _c('i', [_vm._v("Genesis: A Commentary")]), _vm._v(". tr. by J. Bowden. London: SCM Press, 1972. The classic theological commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("J. Rogerson "), _c('i', [_vm._v("Genesis 1—11")]), _vm._v(". Sheffield: Sheffield Academic Press, 1991. Manageable introduction to interpretative issues.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("G. J. Wenham "), _c('i', [_vm._v("Genesis 1—15")]), _vm._v(". Waco: Word Books, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("C. Westermann "), _c('i', [_vm._v("Genesis 1—11: A Commentary")]), _vm._v(". tr. by J. J. Scullion. London: SPCK, 1984. The authoritative German commentary, but it leaves Hebrew words untranslated.")]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-016"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("NEAR EASTERN PARALLELS TO GENESIS 1—11 IN TRANSLATION")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("S. Dalley "), _c('i', [_vm._v("Myths from Mesopotamia")]), _vm._v(". Oxford: Oxford University Press, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A. George "), _c('i', [_vm._v("The Epic of Gilgamesh")]), _vm._v(". London: Penguin, 2000. Excellent introduction and translation.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A. Heidel "), _c('i', [_vm._v("The Gilgamesh Epic and Old Testament Parallels")]), _vm._v(". Chicago: University of Chicago Press, 1949.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("T. Jacobsen ‘The Eridu Genesis’ "), _c('i', [_vm._v("JBL ")]), _vm._v("100, 1981, pp. 513–29. Reprinted in Hess and Tsumura, 1994, pp. 129–42.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("J. B. Pritchard (ed.) "), _c('i', [_vm._v("Ancient Near Eastern Texts relating to the Old Testament")]), _vm._v(". Princeton: Princeton University Press, 1955.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-017"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("ON GENESIS 5")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("D. T. Bryan ‘A Reevaluation of Gen 4 and 5 in the Light of Recent Studies in Genealogical Fluidity’ "), _c('i', [_vm._v("ZAW ")]), _vm._v("99, 1987, pp. 180–88.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("D. W. Young ‘On the Application of Numbers from Babylonian Mathematics to Biblical Life Spans and Epochs’ "), _c('i', [_vm._v("ZAW ")]), _vm._v("100, 1988, pp. 331–61.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("D. W. Young ‘The Influence of Babylonian Algebra on Longevity among the Antediluvians’ "), _c('i', [_vm._v("ZAW ")]), _vm._v("102, 1990, pp. 321–35.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-018"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("ON GENESIS 6—9")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("W. A. van Gemeren ‘The Sons of God in Genesis 6:1–4’ "), _c('i', [_vm._v("WTJ ")]), _vm._v("43, 1981, pp. 320–48.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("R. L. Raikes ‘The Physical Evidence for Noah’s Flood’ "), _c('i', [_vm._v("Iraq ")]), _vm._v("28, 1966, pp. 52–63.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A. J. Tomasino ‘History Repeats Itself: the “Fall” and Noah’s Drunkenness’ "), _c('i', [_vm._v("VT ")]), _vm._v("42, 1992, pp. 128–30.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("D. A. Young "), _c('i', [_vm._v("The Biblical Flood")]), _vm._v(". Grand Rapids: Eerdmans, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("On the Black Sea flood see ")]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.nationalgeographic.com/blacksea",
      "target": "_blank"
    }
  }, [_vm._v("www.nationalgeographic.com/blacksea")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 84
// module chunks = 0